export default __webpack_public_path__ + "static/logo-tesla-b9ffc55530c71ef00e68b9ad58af6073.png";